import AddIconGrey from '../../assets/icons/iconAddGrey.svg';
import './style.scss';
import {Link} from "react-router-dom";

function MeetingItem({meeting}) {
    const baseURL = process.env.REACT_APP_API_URL + process.env.REACT_APP_API_URI;


    function formatDate(meetingDate) {
        let formattedDate = '';
        if (meetingDate) {
            const dateObj = new Date(meetingDate);
            // Format the date into the desired format (DD-MM-YYYY)
            formattedDate = dateObj.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            }).replace(/\//g, '-');
        }
        return formattedDate
    }

    return (
        <div className='meeting-item'>
            <div className='content'>
                <p className='text'>{meeting?.type === 'MEETING' ? `Encuentro ${meeting.order}` : `Evento ${meeting.order}`}</p>

                {meeting?.meeting_date && (<div className='meeting-date'>
                        <p className='date'>Última Edición {formatDate(meeting.updated_at)}</p>
                    </div>
                )}
            </div>


            <div className='meeting-item__container'>
                <div className='images-container'>
                    {meeting?.meetingImages?.length > 0 ? (
                        <>
                            {meeting.meetingImages.map((m, i) => (
                                <img key={i} className='photo1'
                                     src={`${baseURL}/image?imageId=${m.id}&thumbnail=${(!!m.thumbnail)}`} alt=''/>
                            ))}
                        </>
                    ) : (
                        <>
                            <div className='iconGrey'> <img src={AddIconGrey} alt=''/> </div>
                            <div className='iconGrey'> <img src={AddIconGrey} alt=''/> </div>
                            <div className='iconGrey'> <img src={AddIconGrey} alt=''/> </div>
                        </>
                    )}
                </div>
                <Link
                    className='meeting-item__container__btn btn'
                    to={`/escuelas/grupo/lista_de_encuentros/encuentro?encuentro=${meeting.id}`}>
                    <span className='btn__text'>Editar </span>
                    <span className='material-symbols-rounded btn__icon'>
                              edit_square
                            </span>
                </Link>
            </div>
        </div>
    );
}

export default MeetingItem;